(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["centered-sticky-menu"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const nav      = document.querySelector('.csm-nav');
  const guardTop = document.querySelector('.csm-guard-top');
  const guardBot = document.querySelector('.csm-guard-bottom');
  const links    = Array.from(document.querySelectorAll('.csm-link'));
  const sections = Array.from(document.querySelectorAll('.csm-hero'));
  const footer   = document.querySelector('footer, .footer, .site-footer, #shopify-section-footer');

  // Smooth scroll for internal anchors
  /*links.forEach(a => {
    a.addEventListener('click', e => {
      const href = a.getAttribute('href') || '';
      if (href.startsWith('#')) {
        e.preventDefault();
        const t = document.querySelector(href);
        if (t) t.scrollIntoView({ behavior:'smooth', block:'start' });
      }
    });
  });*/
  // Single tap = scroll, double tap (second tap quickly) = navigate
  const DOUBLE_TAP_DELAY = 450; // ms
  const lastTap = new WeakMap();

  links.forEach(a => {
    a.addEventListener('click', (e) => {
      const href = a.getAttribute('href') || '';
      const dblUrl = a.dataset.dblUrl; // from data-dbl-url
      const now = Date.now();
      const prev = lastTap.get(a) || 0;

      // If there's a dbl URL AND the user tapped twice quickly -> go there
      if (dblUrl && (now - prev) <= DOUBLE_TAP_DELAY) {
        e.preventDefault();
        window.location.href = dblUrl;
        return;
      }

      // First tap: store tap time
      lastTap.set(a, now);

      // Do your normal smooth scroll
      if (href.startsWith('#')) {
        e.preventDefault();
        const t = document.querySelector(href);
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Active highlight
  const activeIO = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const handle = entry.target.dataset.handle;
      links.forEach(a => a.setAttribute('aria-current', a.dataset.handle === handle ? 'true' : 'false'));
    });
  }, { threshold: 0.6 });
  sections.forEach(s => activeIO.observe(s));

  // Show only inside this section; keep showing in footer until its BOTTOM is reached
  function updateNav() {
    if (!guardTop || !guardBot || !nav) return;

    const EARLY_PX = 120; // reveal a bit before the first banner
    const topY    = guardTop.getBoundingClientRect().top;
    const bottomY = guardBot.getBoundingClientRect().top;

    const topPassedEarly = topY <= EARLY_PX;
    const sectionEnded   = bottomY <= 0;

    // Hide only when the bottom of the footer hits the bottom of the viewport
    let footerBottomReached = false;
    if (footer) {
      const fr = footer.getBoundingClientRect();
      footerBottomReached = fr.bottom <= (window.innerHeight + 1); // +1 px tolerance
    }

    const shouldShow = topPassedEarly && !sectionEnded && !footerBottomReached;
    nav.classList.toggle('is-visible', shouldShow);
  }

  updateNav();
  window.addEventListener('scroll', updateNav, { passive:true });
  window.addEventListener('resize', updateNav);
});

  } catch(e) { console.error(e); }
})();
})();
